export enum GlobalsJsBaseControllerType {
	GEOMETRY = 'geometry',
}
